// extracted by mini-css-extract-plugin
export default {"breadcrumb":"index__breadcrumb--NCKEl","breadcrumbItem":"index__breadcrumbItem--ZYA0j","divisionIcon":"index__divisionIcon--tWtLp"};